function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import merge from 'lodash/merge';
import COLORS from './colors';
import FONTS from './fonts';
var AMBER = COLORS.AMBER,
    BLUE = COLORS.BLUE,
    GREY = COLORS.GREY,
    WHITE = COLORS.WHITE,
    BLACK = COLORS.BLACK;
/*
 * All ratios will be proportional to the pixels described below
 */

export var BASE_PROPORTION_RATIO = 8;
export var ANIMATIONS = {
  duration: '0.3s',
  timingFunction: 'ease-in-out'
};
export var CORE_SHADOWS = {
  default: '0px 5px 10px 0px rgba(0,0,0,0.2)'
};
export var BREAKPOINTS = {
  lg: 1200,
  md: 992,
  sm: 768,
  xsm: 600
};
export var DEPTHS = {
  base: 1,
  navDropdown: 100,
  overlay: 1100,
  dialog: 1200,
  tooltip: 1300
};
export var BASE = {
  animations: ANIMATIONS,
  baseRatio: BASE_PROPORTION_RATIO,
  breakPoints: BREAKPOINTS,
  depth: DEPTHS,
  font: FONTS,
  palette: COLORS,
  shadows: CORE_SHADOWS
};
export var CORE_COLORS = {
  brand: {
    black: BLACK,
    white: WHITE,
    amber: AMBER[500]
  }
};
export var HEADER = {
  colors: {
    background: BLACK,
    text: WHITE,
    titleBar: {
      border: GREY[500]
    },
    menu: {
      active: BLUE[500],
      background: GREY[750],
      hover: GREY[850]
    },
    link: {
      active: BLUE[400],
      hover: BLUE[300]
    },
    iconLink: {
      hover: GREY[750],
      active: GREY[500],
      dropdown: {
        background: GREY[750],
        border: GREY[700],
        hover: GREY[850]
      }
    }
  }
};
export var FOOTER = {
  colors: {
    background: BLACK,
    text: GREY[350],
    divider: "1px solid ".concat(GREY[650])
  }
};
export function themeCreator(overrider, baseTheme) {
  return overrider(BASE, {
    colors: CORE_COLORS,
    header: HEADER,
    footer: FOOTER,
    buttons: {},
    formElements: {},
    overlays: {},
    tables: {}
  }, baseTheme);
}
/* eslint-disable no-underscore-dangle */

export var themeOverrider = function themeOverrider(baseTheme, override) {
  return themeCreator(function (coreBase, _ref) {
    var coreButtons = _ref.buttons,
        coreFormElements = _ref.formElements,
        coreHeader = _ref.header,
        coreFooter = _ref.footer,
        coreTables = _ref.tables;
    var colors = merge({}, baseTheme._utilities.colors, override.colors);
    return _objectSpread({
      name: override.name || baseTheme.name
    }, coreBase, {
      colors: colors,
      header: _objectSpread({}, coreHeader, {}, baseTheme._utilities.header),
      footer: _objectSpread({}, coreFooter, {}, baseTheme._utilities.footer),
      buttons: _objectSpread({}, coreButtons, {}, merge({}, baseTheme._utilities.buttons(colors), override.buttons)),
      tables: _objectSpread({}, coreTables, {}, merge({}, baseTheme._utilities.tables(colors), override.tables)),
      formElements: _objectSpread({}, coreFormElements, {}, merge({}, baseTheme._utilities.formElements(colors), override.formElements)),
      pagination: baseTheme._utilities.pagination(colors),
      stepper: baseTheme._utilities.stepper(colors),
      popovers: baseTheme._utilities.popovers,
      shadows: _objectSpread({}, coreBase.shadows, {}, baseTheme._utilities.shadows),
      slider: baseTheme._utilities.slider,
      tabs: baseTheme._utilities.tabs,
      toggleButtonBar: baseTheme._utilities.toggleButtonBar
    });
  });
};
/* eslint-enable no-underscore-dangle */